import { render, staticRenderFns } from "./TwProcessGroupList.vue?vue&type=template&id=0d1eff24&scoped=true&"
import script from "./TwProcessGroupList.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupList.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupList.vue?vue&type=style&index=0&id=0d1eff24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1eff24",
  null
  
)

export default component.exports